import React from 'react';
import { connect } from 'react-redux';

import BaseComponent from '../../../../baseClasses/BaseComponent';
import VideoPlayer from '../../../../components/VideoPlayer';
import spinner from '../../../../assets/images/loader.svg';
import Download from '../../../../components/Download';
import ProgressIndicator from '../../../../components/ProgressIndicator';
import FileUploader from '../../../../components/FileUploader';
import swapButton from '../../../../assets/images/swap-blue.svg';
import documentIcon from '../../../../assets/images/document-icon-light-gray.svg';
import dataModel from '../../../../models/DataModel';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import fileUtil from '../../../../helpers/FileUtil/FileUtil';
import AttachmentHelper from '../../../../helpers/AttachmentHelper';

import './ReferenceDocument.scss';
import { setTimeout } from 'timers';
import referenceDocmentsServices from '../../../../services/referenceDocumentsServices';

// Change Card to the appropriate name
class ReferenceDocument extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      alt: '',
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    let self = this;
    self.timeout = setTimeout(() => {
      self.setState({
        loading: false,
        alt: 'File not available',
      });
    }, 5000);
    if(this.props.referenceDocument){
      this.handleCheckFileUsed();
    }
  }

  handleAssetLoaded(e) {
    this.setState({ loading: false });
    clearTimeout(this.timeout);
  }

  handleFileSwap(file) {
    this.setState({ uploadingFile: true });
    let refDoc = Object.assign({}, this.props.referenceDocument);
    refDoc.upload = file;
    refDoc.name = file.name;

    //log to GA
    const fileType = fileUtil.getExtension(refDoc.name);
    this.analyticsLogger.logRDLSwapEvent(fileType);

    this.props.referenceDocumentsDataModel.referenceDocument = {
      update: refDoc,
      callBack: (referenceDocument) => {
        this.setState({ 
          uploadingFile: false,
        });
        this.props.updateDocument(referenceDocument.reference_document);
      },
    };
    // dataModel.systemPopup = null;
  }

  handleCheckFileUsed(){
    referenceDocmentsServices.checkFileIsInUse(this.props.referenceDocument.id).then((response) =>{
      if(response.error){
      }
      else if(response.data.conflict){
        this.setState({ message: response.data.message });
      }
    });
  }

  handleDisplayPopup(){
    let message = this.state.message;

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      captionText: 'WARNING',
      message: message,
      cancelButtonText: this.textMap.cancel,
      okButtonText: this.textMap.yes,
      width: 320,
      height: 220,
      useInput: true,
      handleOwnerOk: this.handleFileSwap,
    });
  }

  render() {
    const { referenceDocument } = this.props;

    if (!referenceDocument) {
      return null;
    }

    let loading;
    const uploadedFile = referenceDocument.attachment;

    let vidWidth = 775 - 160;
    let imageDisplay = null;

    if (this.state.loading) {
      loading = <img className='spinner' src={spinner} alt='spinner' />;
    }

    switch (referenceDocument.attachment_content_type) {
    case 'image/jpeg':
    case 'image/jpg':
    case 'image/png':
    case 'image/gif':
      imageDisplay = 
          <div className="display-image">
            <img className="display-image" src={uploadedFile} alt={this.state.alt} onLoad={this.handleAssetLoaded} />
          </div>;
      break;
    case 'video/mp4':
    case 'video/quicktime':
      const type = uploadedFile && uploadedFile.upload_content_type ? uploadedFile.upload_content_type : (uploadedFile && uploadedFile.upload && uploadedFile.upload.type) ? uploadedFile.upload.type : undefined;
      imageDisplay = 
          <div className="display-video">
            <VideoPlayer width={vidWidth} src={uploadedFile} onLoad={this.handleAssetLoaded} alt={this.state.alt} type={type} />
          </div>;
      break;
    case 'application/pdf':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/msword':
      imageDisplay = AttachmentHelper.getConvertedDocumentView(referenceDocument);
      break;
    default:
      let content = <div>
            <div className="no-documents-icon" />
            <div className="no-documents-text">
              This file type can't be previewed
            </div>
            <div className="no-documents-text">Click to download</div>
          </div>;

      imageDisplay = <Download content={content} className={'non-display-file-type'} download={referenceDocument.name} href={uploadedFile} />;
      loading = null;
      break;
    }
    let swapBtn = (
      <div className='reference-document-swap-button-container'>
        <FileUploader 
          handleFileSelect={this.handleFileSwap}
          img={swapButton}
        />
      </div>
    );
    if(this.state.message){
      swapBtn = (
        <div className='reference-document-swap-button' onClick={this.handleDisplayPopup}/>
      );
    }
    if(this.state.uploadingFile){
      imageDisplay = (
        <div className='reference-document-loading-icon'>
          <img className='reference-document-image' src={documentIcon} alt='document-icon'/>
          <div className='reference-document-progress-indicator'>
            <ProgressIndicator
              height={4}
              width={250}
            />
          </div>
        </div>
      );
      swapBtn = null;
    }

    return (
      <div className="reference-document" >
        {loading}
        <div className="caption-container">
          { !this.state.uploadingFile &&
            <div className="caption">{referenceDocument.name}</div>
          }
        </div>
        <div className="display-container">
          {imageDisplay}
          {swapBtn}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    referenceDocumentsDataModel: dataModel.referenceDocumentsDataModel,
  };
};

export default connect(mapStateToProps)(ReferenceDocument);



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentDisplay/ReferenceDocument/index.js